/**
 * Roles event types for durable event recording (roles:*).
 */
export enum RolesEventType {
  ROLE_CREATED = 'roles:role.created',
  ROLE_UPDATED = 'roles:role.updated',
  ROLE_DELETED = 'roles:role.deleted',
  ROLE_ASSIGNED = 'roles:role.assigned',
  ROLE_UNASSIGNED = 'roles:role.unassigned',
  ROLE_REFRESHED = 'roles:role.refreshed',
}

/**
 * Pub/sub channel for roles events.
 */
export const ROLES_EVENTS_CHANNEL = 'roles:events';